import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminStatsClicks = lazy(() => import("@/pages/admin/AdminStatsClicks"));

export const Route = createFileRoute("/admin/statistik/klick")({
  component: () => <AdminStatsClicks />,
});
